import script from "./documentBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./documentBubble.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=6516fe53&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6516fe53"]])

export default __exports__